import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

const InputFilter = (props) => {
	const { handleFilterByInput } = props;

	const [input, setInput] = React.useState('');

	const handleInput = (value) => {
		setInput(value);
		handleFilterByInput(input);
	};

	return (
		<Stack
			m={1}
			sx={{
				px: { xs: 1, md: 2 }
			}}
		>
			<FormControl>
				<Typography variant='h3' sx={{ fontSize: '1.2rem', mb: '7px' }}>
					<FormLabel htmlFor='search-gc' sx={{ fontSize: '1.2rem', color: '#000' }}>
						Filter
					</FormLabel>
				</Typography>
				<TextField
					sx={{ m: 0 }}
					placeholder='Search'
					value={input}
					id='search-gc'
					aria-label='Search Gift Card'
					onChange={(e) => handleInput(e.target.value)}
					InputProps={{
						inputProps: {
							style: { padding: '10px' }
						}
					}}
				/>
			</FormControl>
		</Stack>
	);
};

InputFilter.propTypes = {
	handleFilterByInput: PropTypes.func
};

export default InputFilter;
